import React from "react";
import { goToCheckout, PRICE, PRICE_OLD } from "../lib/data";
export function StickyBar() {
  return <div className="fixed inset-x-0 bottom-0 z-30 border-t border-slate-200 bg-white/95 px-4 py-3 backdrop-blur" data-id="element-195" data-mp="12mjtyfzxrs7n">
      <div className="mx-auto flex max-w-md items-center gap-3" data-id="element-196" data-mp="xth7ssxhnl1h">
        <div className="shrink-0 leading-none" data-id="element-197" data-mp="sw7dayv8sj6s">
          <span className="block text-xs text-slate-400 line-through" data-id="element-198" data-mp="svfi3p5k4nh1">{PRICE_OLD}</span>
          <span className="font-display text-lg font-extrabold text-slate-900" data-id="element-199" data-mp="ny5sa8e9a9so">{PRICE}</span>
        </div>
        <button type="button" onClick={goToCheckout} className="flex-1 rounded-xl bg-teal-600 px-4 py-3 text-center text-sm font-extrabold text-white shadow-md transition-colors hover:bg-teal-700 active:scale-[0.98]" data-id="element-200" data-mp="jtpocco7dcg3">
          Quiero mi megapack
        </button>
      </div>
    </div>;
}